import { patchRequest } from '@/core';
import { drivers } from '@/requests';

export default async function updateDriverRequest(id, patch) {
	let url = drivers.getByIdPath(id);
	return patchRequest(url, {}, patch);
}